import { Tag } from "antd";
import { useAppSelector } from "../../../../../../app/store";
import { TicketWorkflow } from "../../../../../../features/superAdmin/ticketService/ticket/ticket.type";
import {
  convertMinutesToSeconds,
  convertSecondsToHoursShort,
  formatDate,
  formatTime,
  getSecondsDiff,
} from "../../../../../../lib/time";
import { cn } from "../../../../../../utils/string";

const SLAActivityItem = ({ workFlow }: { workFlow: TicketWorkflow }) => {
  const user_id = useAppSelector((state) => state?.auth?.user?.id);

  const {
    is_forwarded,
    is_resolved,
    role_type,
    employee_id,
    employee,
    visibility_duration_minutes: vMinutes,
    start_time,
    end_time,
    status,
  } = workFlow;
  console.log(start_time, end_time);
  const diffInSeconds = getSecondsDiff(end_time, start_time);
  const visibilityInSecond = convertMinutesToSeconds(vMinutes);
  const isDone = is_resolved || is_forwarded || status === "passed";
  const isAssignedUser = employee_id === user_id;

  const employeeName = employee?.officialInfo?.name || "Unknown";
  const isBreached = diffInSeconds >= visibilityInSecond;

  let openStatus = "Will Check";
  if (is_forwarded) openStatus = "Forwarded";
  if (is_resolved) openStatus = "Resolved";
  if (status === "passed") openStatus = "Passed";

  return (
    <div>
      <div
        className={cn(
          `font-semibold text-base`,
          isDone || isAssignedUser ? "text-body" : "text-display-dark",
        )}
      >
        Ticket {openStatus}
        {role_type === "cc" && " CC"}
        &nbsp;{openStatus === "Passed" ? "from" : "by"} {employeeName}
        {isAssignedUser ? (
          <Tag className="ml-2 bg-status-dark-bg text-body border-none">
            You
          </Tag>
        ) : null}
      </div>
      <div className="space-y-[5px] mt-[5px]">
        <div className="flex items-center">
          <span className="text-[#5E718D]">
            {formatTime(start_time, "h:mm:ss")} - {formatDate(start_time)}
            &nbsp;
          </span>
          <span className="text-body font-medium">
            - Base SLA:&nbsp;
            {convertSecondsToHoursShort(visibilityInSecond)}
          </span>
        </div>
        {isDone ? (
          <>
            <div className="text-gray-500 flex items-center gap-2 flex-wrap">
              <span className="text-body font-medium text-nowrap">
                Completion SLA:&nbsp;
                {convertSecondsToHoursShort(diffInSeconds)} -
              </span>

              <span className="text-body font-medium text-nowrap">
                SLA Status:&nbsp;
                {isBreached ? (
                  <span className="text-xs inline-block px-2 py-[4.5px] rounded-full bg-[#FFF5F4] text-[#FF3838]">
                    Breached
                  </span>
                ) : (
                  <span className="text-xs inline-block px-2 py-[4.5px] rounded-full bg-status-dark-bg text-body">
                    Normal
                  </span>
                )}
              </span>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};
export default SLAActivityItem;
